import { render, staticRenderFns } from "./TemplateListAddNew.vue?vue&type=template&id=0f5c0b46&"
import script from "./TemplateListAddNew.vue?vue&type=script&lang=js&"
export * from "./TemplateListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./TemplateListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports